import { buildings } from "../../data/settings.json";
const isMobileInitial = window.innerWidth < 960;

const initialState = {
	window: {
		width: window.innerWidth
	},
	sidebar: {
		hidden: isMobileInitial,
		opened: !isMobileInitial
	},
	search: {
		hidden: true,
		opened: false
	},
	media: {
		hidden: true,
		opened: false
	},
	isMobile: isMobileInitial,
	routeName: "/",
	building: buildings[0]
};

export default initialState;
